import React from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';
import useLore from '../../hooks/useLore';
import RichTextContent from 'components/RichTextContent/RichTextContent';

import './SingleLore.scss';
import { routes } from '../../routing/routes';

const TEST_LORE_POST_ID = '2KyyUHCwL7VFZMJgfrv466';

export default function SinglePost({ shouldRenderTestPost }) {
  const { id } = useParams();

  const loreId = shouldRenderTestPost ? TEST_LORE_POST_ID : id;
  const { getById, isLoading } = useLore(loreId);
  const lore = getById(loreId);

  if (isLoading || !lore) {
    return null;
  }

  const { title, imageUrl, content } = lore;

  const heroimg = {
    background: 'url(' + imageUrl + ') no-repeat center center',
    backgroundSize: 'cover',
  };

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="media"
    >
      <Helmet>
        <title>{`${title} - DuskBreakers`}</title>
        <meta
          name="description"
          content="Explore the universe of DuskBreakers and learn more about life as a Breaker."
        />
      </Helmet>

      <section className="height-80 mobile-height-60 impact has-bg">
        <div className="is-bg fade-homehero" style={heroimg} />
      </section>

      <section className="mt-n7 single-lore-container">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-8">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.lore.base()}>Lore</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {title}
                  </li>
                </ol>
              </nav>
              <h1 className="text-start mb-5">
                <span>{title}</span>
              </h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-8">
              <div className="post">
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <div className="post__body" id={`lore-id-${id}`}>
                      <RichTextContent node={content} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
